import { REQUEST_STATUS_SELECT } from './RequestStatus.actionTypes'

export function selectStatus (value) {
  return { type: REQUEST_STATUS_SELECT, value }
}
